import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#062029] text-[#F7F5F0] relative grain overflow-hidden" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <p className="label text-[#C5A880]">Salvatore Business Gateway</p>
            <h3 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.05] max-w-xl">
              {t.footer.tagline}
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-block mt-10 border border-[#C5A880]/60 px-7 py-3 text-[12px] tracking-widest uppercase hover:bg-[#C5A880] hover:text-[#062029] transition-colors duration-500"
            >
              {t.nav.cta}
            </Link>
          </div>
          <div className="md:col-span-3 md:col-start-9">
            <p className="label text-[#C5A880]">{t.nav.gateways}</p>
            <ul className="mt-6 space-y-3 font-body text-sm text-[#F7F5F0]/75">
              <li><Link className="link-underline" to="/services">{t.nav.services}</Link></li>
              <li><Link className="link-underline" to="/gateways">{t.nav.gateways}</Link></li>
              <li><Link className="link-underline" to="/investment">{t.nav.investment}</Link></li>
              <li><Link className="link-underline" to="/network">{t.nav.network}</Link></li>
              <li><Link className="link-underline" to="/about">{t.nav.about}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-[#F7F5F0]/12 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#F7F5F0]/50 font-body tracking-wide">
          <span>© {year} SBG — Salvatore Business Gateway. {t.footer.rights}</span>
          <span>Belgrade · Vienna · Dubai · Zürich</span>
        </div>
      </div>
    </footer>
  );
}
